import React, { useMemo, useState } from 'react';
import DataTable from '../DataTable';
import Button from '../common/Button';
import { t } from '../../i18n';

const rows = [
  {
    contrato: 'Ingenieria y EPC Parque Leyda',
    contratista: 'ConstruSolar SpA',
    avance: 72,
    financiero: 64,
    monto: 6800000,
    reclamos: 1,
    subcontratos: 2,
    documentos: 2,
    estado: 'En ejecucion'
  },
  {
    contrato: 'Balance of Plant Hurtado',
    contratista: 'InfraPower Latam',
    avance: 48,
    financiero: 45,
    monto: 5400000,
    reclamos: 1,
    subcontratos: 1,
    documentos: 1,
    estado: 'Con alertas'
  },
  {
    contrato: 'Suministro BESS Leyda',
    contratista: 'PowerStorage Consortium',
    avance: 85,
    financiero: 82,
    monto: 3200000,
    reclamos: 0,
    subcontratos: 0,
    documentos: 2,
    estado: 'En pruebas'
  }
];

const SuppliersLegalAdmin = () => {
  const [statusFilter, setStatusFilter] = useState('Todos');

  const filtered = useMemo(() => {
    if (statusFilter === 'Todos') return rows;
    return rows.filter((row) => row.estado === statusFilter);
  }, [statusFilter]);

  const columns = [
    { key: 'contrato', label: t('Contrato'), sortable: true },
    { key: 'contratista', label: t('Contratista'), sortable: true },
    { key: 'estado', label: t('Estado'), sortable: true },
    {
      key: 'avance',
      label: t('Avance'),
      sortable: true,
      render: (value) => (
        <div className="min-w-[6rem]">
          <div className="w-24 h-1.5 bg-neutral-200 rounded-sm overflow-hidden mb-1">
            <div className="h-full bg-brand-600" style={{ width: `${value}%` }} />
          </div>
          <span className="num">{t(value)}%</span>
        </div>
      )
    },
    { key: 'financiero', label: t('Financiero'), sortable: true, align: 'right', render: (value) => `${value}%` },
    { key: 'monto', label: t('Monto'), sortable: true, align: 'right', render: (value) => `$${value.toLocaleString('es-CL')}` },
    { key: 'reclamos', label: t('Reclamos'), sortable: true, align: 'right' },
    { key: 'subcontratos', label: t('Subcontratos'), sortable: true, align: 'right' },
    { key: 'documentos', label: t('Documentos'), sortable: true, align: 'right' },
    {
      key: 'acciones',
      label: t('Acciones'),
      render: () => (
        <div className="flex flex-col gap-1 items-start">
          <Button variant="secondary" size="sm">{t('Ver detalle')}</Button>
          <Button variant="secondary" size="sm">{t('Registrar avance')}</Button>
          <Button variant="secondary" size="sm">{t('Subir doc')}</Button>
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-neutral-900">{t('Info Legal y Administrativa')}</h1>
          <p className="text-sm text-neutral-500">{t('Contratos, avances, reclamos y documentacion de proveedores.')}</p>
        </div>
        <select
          value={statusFilter}
          onChange={(event) => setStatusFilter(event.target.value)}
          className="h-8 px-3 rounded border border-neutral-300 text-sm focus:outline-none focus:ring-1 focus:ring-brand-400 focus:border-brand-400"
        >
          <option>{t('Todos')}</option>
          <option>{t('En ejecucion')}</option>
          <option>{t('Con alertas')}</option>
          <option>{t('En pruebas')}</option>
        </select>
      </div>

      <DataTable
        data={filtered.map((row) => ({ ...row, id: row.contrato }))}
        columns={columns}
        searchPlaceholder={t('Buscar contrato o contratista...')}
      />
    </div>
  );
};

export default SuppliersLegalAdmin;
